import useModal from "@rf/base/modal/useModal";
import { ReportPropertyTemplateModal } from "./components/ReportPropertyTemplateModal";
import { IReportPropertyArgs } from "./util/model";

const useReportProperty = () => {
  const { modal } = useModal();

  const handleReportProperty = (arg: IReportPropertyArgs) => {
    modal({
      template: <ReportPropertyTemplateModal />,
      data: arg,
      options: {
        title: arg.title || "Reportar propiedad",
        size: {
          xs: {
            width: "100%",
            height: "100%"
          },
          sm: {
            width: "100%",
            height: "100%"
          },
          md: {
            width: "40vw",
            minHeight: "200px"
          },
          lg: {
            width: "40vw",
            minHeight: "200px"
          },
          xl: {
            width: "40vw",
            minHeight: "200px"
          }
        }
      }
    });
  };

  return {
    handleReportProperty
  };
};

export default useReportProperty;
